/** EventSource URL for inspiration gallery ZIP processing progress */
export function getInspirationGalleryUploadProgressUrl(uploadId) {
    return window.location.hostname === "localhost"
        ? `${process.env.REACT_APP_URL}/backend/inspiration-gallery/upload-progress/${uploadId}`
        : `https://pmx.softwareco.com/backend/inspiration-gallery/upload-progress/${uploadId}`;
}
